var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-26.334 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(24.688) scale(.9375)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-69 0h768v512H-69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01017e",
    d: "M-69 170.67h768V512H-69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe0101",
    d: "M-69 341.33h768V512H-69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.736 116.2v143.57c9.833 56.051 35.893 113.09 123.9 142.09 87.519-29.009 115.54-83.586 125.87-143.08V116.19H64.736z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.569 127.51v125.38c8.85 45.726 26.059 108.17 114.07 137.18 87.519-29.009 107.68-91.452 115.54-137.18V127.51H74.569z",
    fill: "#fe0101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41 203.23v20.159h40.318c5.406 0 10.489-2.623 15.734-3.934v37.859c-5.409-1.147-10.696-3.441-16.226-3.441h-39.334v46.218l-27.043-.984v-45.234h-38.35c-5.764 0-11.144 2.95-16.717 4.425v-40.317c5.245 1.639 10.239 4.916 15.734 4.916h39.334v-20.159h-29.009c-5.083 0-9.506 3.606-14.259 5.41v-38.35c5.409 2.294 10.35 6.882 16.226 6.882h27.534v-17.209c0-8.037-4.59-15.406-6.884-23.109h38.842c-1.967 7.867-5.9 15.492-5.9 23.601v16.717h26.06c6.799 0 13.111-3.605 19.667-5.408v37.86c-5.9-1.967-11.482-5.901-17.7-5.901H202.41z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.75 305.5c-23.11-11.555-45.184-5.102-55.744 13.398 16.41 31.344 47.632 56.666 91.637 71.17 43.76-14.505 75.596-39.826 93.05-69.695-13.597-25.94-39.457-22.495-56.174-14.381-11.8-29.009-59.985-27.534-72.768-.492z",
    fill: "#01017e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.5e8dab1e9552c23527357b7f1319892d.svg";
export { ForwardRef as ReactComponent };